<app-section-loader [loading]="loading"></app-section-loader>
<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">
  {{ importPhase === 3 ? "Imported Tutor Report" : "Import Tutors" }}
</h2>
<div *ngIf="importPhase === 1">
  <mat-dialog-content>
    <div class="form-group">
      <div class="label">
        Upload from file
        <span *ngIf="!IsFile" class="text-danger" style="font-size: 12px"
          >*
        </span>
        <small style="margin-left: 2px" class="text-danger">
          (Accepted file format - .xlsx)</small
        >
      </div>
      <div class="file-upload">
        <input
          #fileInput
          type="file"
          accept=".xlsx"
          id="file"
          (change)="onUpload($event)"
          style="visibility: hidden"
          (click)="$event.target.value = null"
        />
        <div class="file-upload-text">
          {{ fileName ? fileName : "Select a file" }}
        </div>
        <button mat-raised-button color="primary" (click)="fileInput.click()">
          Browse
        </button>
      </div>
    </div>
    <div class="mb-3">
      <a
        class="template-download mr-2"
        href="https://hugdevs3.s3.amazonaws.com/Templates/ImportTutorBlankTemplate.xlsx"
        download
        >Download a blank template</a
      >
      <small class="text-danger mr-auto"
        >(All highlighted fields are required)</small
      >
    </div>
    <form [formGroup]="tutorForm">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Associated School(s)</mat-label>
        <mat-select
          disableOptionCentering
          multiple
          formControlName="schools"
          [(value)]="schoolIds"
          (selectionChange)="schoolSelected($event)"
          required
        >
          <mat-option>
            <ngx-mat-select-search
              style="width: 100%"
              [formControl]="schoolControl"
              [noEntriesFoundLabel]="'No matching schools found'"
              placeholderLabel="Search School"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let school of schoolOptions" [value]="school.id">
            {{ school?.school_name }}
            {{ school.uuid ? "(" + school.uuid + ")" : "" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="added-list" *ngIf="selectedSchools?.length">
        <div class="list-loop mr-2" *ngFor="let sch of selectedSchools">
          <div class="d-flex align-items-center">
            <div
              class="flex-fill mr-2"
              matTooltip="{{ sch.school_name }} {{
                sch.uuid ? '(' + sch.uuid + ')' : ''
              }}"
            >
              {{ sch.school_name }} {{ sch.uuid ? "(" + sch.uuid + ")" : "" }}
            </div>
            <div class="flex-auto">
              <span class="card-close pointer" onclick="">
                <em
                  class="material-icons"
                  style="font-size: 12px"
                  (click)="schoolRemoved(sch.id)"
                  >close</em
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="importTutors()"
      [disabled]="!importTutorModal?.file || !selectedSchools.length"
    >
      Upload
    </button>
    <!--!selectedSchools?.length>0 -->
  </mat-dialog-actions>
</div>
<div *ngIf="importPhase === 2">
  <mat-dialog-content *ngIf="importSuccessful">
    <div class="alert-message-popup min-width-100">
      <a class="text-success">
        <mat-icon style="font-size: 40px">check_circle</mat-icon>
      </a>
      <h2 class="h1 my-3">File uploaded successfully !</h2>
      <p
        class="mb-0"
        *ngIf="successReport?.tutorsImported?.imported?.length > 0"
      >
        {{ successReport?.tutorsImported?.imported?.length }} tutors
        successfully imported
      </p>
      <p
        class="mb-0"
        *ngIf="successReport?.tutorsImported?.updated?.length > 0"
      >
        {{ successReport?.tutorsImported?.updated?.length }} tutors successfully
        updated
      </p>
      <p
        class="text-danger mb-0"
        *ngIf="successReport?.tutorsImported?.failed?.length > 0"
      >
        {{ successReport?.tutorsImported?.failed?.length }} tutors failed to
        import
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="importSuccessful">
    <button mat-button (click)="importPhase = 3" *ngIf="tutorDetails">
      View Details
    </button>
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      (click)="dialogRef.close(true)"
    >
      Done
    </button>
  </mat-dialog-actions>
  <mat-dialog-content *ngIf="!importSuccessful">
    Uh oh, something went wrong! Please try again
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="!importSuccessful">
    <button mat-button (click)="dialogRef.close(false)">Dismiss</button>
    <button mat-raised-button color="primary" (click)="resetForm()">
      Try Again
    </button>
  </mat-dialog-actions>
</div>
<div *ngIf="importPhase === 3">
  <mat-dialog-content>
    <div *ngIf="successReport?.tutorsImported?.imported?.length">
      <p class="modal-text m-0">
        {{ successReport?.tutorsImported?.imported?.length }} tutors added
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li
            class="col-md-6"
            *ngFor="let tutor of successReport?.tutorsImported?.imported"
          >
            <span class="text"
              >{{ tutor.first_name }} {{ tutor.second_name }}
              {{ tutor.last_name }}</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.tutorsImported?.updated?.length">
      <p class="modal-text m-0">
        {{ successReport?.tutorsImported?.updated?.length }} tutors updated
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li
            class="col-md-6"
            *ngFor="let tutor of successReport?.tutorsImported?.updated"
          >
            <span class="text"
              >{{ tutor.first_name }} {{ tutor.second_name }}
              {{ tutor.last_name }}</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.tutorsImported?.failed?.length">
      <p class="modal-text m-0">
        {{ successReport?.tutorsImported?.failed?.length }} tutors failed
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li
            class="col-md-6"
            *ngFor="let status of successReport?.tutorsImported?.failed"
          >
            <span class="text"
              >{{ status.first_name }} {{ status.second_name }}
              {{ status.last_name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
      Dismiss
    </button>
  </mat-dialog-actions>
</div>
